import { Tag } from 'antd';

import {
    SupportTicketPriorities, SupportTicketPriority,
} from '@/constants';

type PriorityTagProps = {
    priority: SupportTicketPriority;
};

const getPriorityColor = (priority: SupportTicketPriority): string => {
    switch (priority) {
        case SupportTicketPriority.Low:
            return 'blue';
        case SupportTicketPriority.Normal:
            return 'green';
        case SupportTicketPriority.Critical:
            return 'red';
        default:
            return 'default';
    }
};

export const PriorityTag = ({ priority }: PriorityTagProps) => {
    const color = getPriorityColor(priority);
    const label = SupportTicketPriorities[priority];

    return (
        <Tag color={color}>
            {label}
        </Tag>
    );
};
